/**
 * E6000 10-11 scroll morph（sections/E6000-10-11.liquid）
 *
 * PC：track 固定高度（100vh + 160vh）+ sticky viewport。
 * 滚动路程由 track 撑开，GSAP 只负责读取进度，避免 pin 切换 fixed 时闪屏。
 *
 * Progress 阶段（onUpdate 阈值 + timeline 位置）：
 *   0        — 第一屏：hero 文案 + 右侧无框图，折线隐藏
 *   0–0.18   — 定屏停留，保持第一屏初始画面
 *   ≥0.30    — LINE_REVEAL_AT：折线 clip-path 露出
 *   ~0.50    — FRAME_HERO_AT：hero 淡出 → 手机框淡入（约 1.2s 序列动效）
 *   动效结束后 — 机内第一屏内容淡入
 *   0.68–0.95 — timeline：手机位移+缩放到终位
 *   ≥0.72    — SECOND_SCREEN_AT：第二屏（文案、背景、机内图切换）
 *   ~0.94+   — 空 tween 保持终态
 *
 * Mobile：第一屏 sticky + 折线/光晕 scrub；第二屏 IO 进入激活。
 */
(function () {
  'use strict';

  if (window.__samduoScrollMorphV5Loaded) {
    if (typeof window.__samduoScrollMorphV5Init === 'function') {
      window.__samduoScrollMorphV5Init();
    }
    return;
  }

  window.__samduoScrollMorphV5Loaded = true;

  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var initObserver = null;
  var hasInitialized = false;
  var lastViewportWidth = window.innerWidth;
  var lastMobileState = mobileQuery.matches;

  function prepareSectionImages(section) {
    var selector = mobileQuery.matches
      ? '.scroll-morph-v5__mobile-static img'
      : '.scroll-morph-v5__track img';
    var images = Array.prototype.slice.call(section.querySelectorAll(selector));

    images.forEach(function (image) {
      image.loading = 'eager';
      image.fetchPriority = 'auto';
    });

    var decodes = images.map(function (image) {
      if (typeof image.decode !== 'function') return Promise.resolve();
      return image.decode().catch(function () {});
    });

    return Promise.race([
      Promise.all(decodes),
      new Promise(function (resolve) {
        setTimeout(resolve, 1200);
      })
    ]);
  }

  function initMobileScreens() {
    document.querySelectorAll('.scroll-morph-v5').forEach(function (section) {
      destroySection(section);

      var screens = section.querySelectorAll('.scroll-morph-v5__mobile-screen');
      if (!screens.length) return;

      var firstTrack = section.querySelector('.scroll-morph-v5__mobile-first-track');
      var firstScreen = section.querySelector('.scroll-morph-v5__mobile-screen[data-mobile-screen="1"]');
      var mobileLine = section.querySelector('.scroll-morph-v5__mobile-line-image');
      var mobileGlow = section.querySelector('.scroll-morph-v5__mobile-glow');

      screens.forEach(function (screen, index) {
        if (index === 0) screen.classList.add('is-active');
      });

      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && firstTrack && firstScreen) {
        gsap.registerPlugin(ScrollTrigger);

        section.__scrollMorphContext = gsap.context(function () {
          if (mobileLine) {
            gsap.set(mobileLine, { clipPath: 'inset(0 100% 0 0)' });
          }

          if (mobileGlow) {
            gsap.set(mobileGlow, { opacity: 0.95, scale: 1 });
          }

          var tl = gsap.timeline({
            scrollTrigger: {
              id: 'e6000-10-11-mobile-' + (section.dataset.sectionId || ''),
              trigger: firstTrack,
              start: 'top top',
              end: 'bottom bottom',
              scrub: 1,
              refreshPriority: 20,
              invalidateOnRefresh: true
            }
          });

          if (mobileLine) {
            tl.to(mobileLine, {
              clipPath: 'inset(0 0% 0 0)',
              duration: 0.58,
              ease: 'none'
            }, 0.02);
          }

          if (mobileGlow) {
            tl.to(mobileGlow, {
              opacity: 0,
              scale: 0.92,
              duration: 0.34,
              ease: 'power1.out'
            }, 0.16);
          }
        }, section);

        if (typeof window.samduoRefreshScrollTrigger === 'function') {
          window.samduoRefreshScrollTrigger();
        }
      } else if (mobileLine) {
        mobileLine.style.clipPath = 'inset(0 0% 0 0)';
      }

      if (!('IntersectionObserver' in window)) {
        screens.forEach(function (screen) {
          screen.classList.add('is-active');
        });
        return;
      }

      section.__scrollMorphMobileObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-active');
        });
      }, { threshold: 0.28 });

      screens.forEach(function (screen) {
        section.__scrollMorphMobileObserver.observe(screen);
      });
    });
  }

  function runDesktop() {
    if (mobileQuery.matches) {
      initMobileScreens();
      return;
    }

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.scroll-morph-v5').forEach(function (section) {
      if (section.dataset.scrollMorphReady === 'true') return;

      var track = section.querySelector('.scroll-morph-v5__track');
      var viewport = section.querySelector('.scroll-morph-v5__viewport');
      var bgScene = section.querySelector('.scroll-morph-v5__bg-scene');
      var bgImg = bgScene ? bgScene.querySelector('img') : null;
      var bgOverlay = section.querySelector('.scroll-morph-v5__bg-overlay');
      var heroText = section.querySelector('.scroll-morph-v5__hero-text');
      var heroVisual = section.querySelector('.scroll-morph-v5__hero-visual');
      var heroImage = section.querySelector('.scroll-morph-v5__hero-image');
      var heroLine = section.querySelector('.scroll-morph-v5__hero-line-image');
      var phone = section.querySelector('.scroll-morph-v5__phone-device');
      var phoneScreens = section.querySelector('.scroll-morph-v5__phone-screens');
      var phoneFrame = section.querySelector('.scroll-morph-v5__phone-frame');
      var screens = Array.prototype.slice.call(section.querySelectorAll('.scroll-morph-v5__screen'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('.scroll-morph-v5__text-panel'));
      var glow = section.querySelector('.svg-ambient-glow');
      var scrollHint = section.querySelector('.scroll-morph-v5__scroll-hint');

      if (!track || !viewport || !heroImage || !phone || !screens.length) return;

      section.dataset.scrollMorphReady = 'true';

      section.__scrollMorphContext = gsap.context(function () {
        var viewportHeight = window.innerHeight;
        var scrollDistance = Math.round(viewportHeight * 1.6);
        track.style.height = (viewportHeight + scrollDistance) + 'px';

        var viewportRect = viewport.getBoundingClientRect();
        var heroRect = heroImage.getBoundingClientRect();
        var phoneWidth = phone.offsetWidth || 390;
        var phoneHeight = phone.offsetHeight || 844;
        var viewportCenterX = viewportRect.width / 2;
        var viewportCenterY = viewportRect.height / 2;

        var heroCenterX = heroRect.left - viewportRect.left + heroRect.width / 2;
        var heroCenterY = heroRect.top - viewportRect.top + heroRect.height / 2;
        var startScale = Math.min(
          Math.max(Math.max(heroRect.width / phoneWidth, heroRect.height / phoneHeight), 0.58),
          2.6
        );

        var finalScale = phoneWidth ? 373 / phoneWidth : 0.437;
        var finalX = window.matchMedia('(max-width: 1023px)').matches
          ? viewportRect.width * 0.18
          : viewportRect.width * 0.28;
        var finalY = window.matchMedia('(max-width: 1023px)').matches
          ? viewportRect.height * 0.26
          : viewportRect.height * 0.18;

        var startState = {
          xPercent: -50,
          yPercent: -50,
          x: heroCenterX - viewportCenterX,
          y: heroCenterY - viewportCenterY,
          scale: startScale,
          opacity: 0,
          visibility: 'visible',
          transformOrigin: 'center center'
        };

        gsap.set(bgScene, { opacity: 0 });
        if (bgImg) gsap.set(bgImg, { scale: 1.12 });
        gsap.set(bgOverlay, { opacity: 1 });
        gsap.set(phone, startState);
        gsap.set(phoneFrame, { opacity: 0 });
        gsap.set(phoneScreens, { opacity: 0 });
        gsap.set(heroText, { autoAlpha: 1, x: 0 });
        if (heroVisual) gsap.set(heroVisual, { autoAlpha: 1, scale: 1 });
        if (heroLine) gsap.set(heroLine, { clipPath: 'inset(0 100% 0 0)' });
        gsap.set(scrollHint, { opacity: scrollHint ? 0.75 : 0 });
        if (glow) {
          gsap.set(glow, { opacity: 0.95, scale: 1 });
          glow.classList.remove('is-hidden');
        }

        screens.forEach(function (screen, index) {
          gsap.set(screen, {
            opacity: index === 0 ? 0 : 0,
            visibility: index === 0 ? 'visible' : 'hidden',
            y: index === 0 ? '0%' : '100%'
          });
        });

        panels.forEach(function (panel, index) {
          gsap.set(panel, {
            autoAlpha: 0,
            x: index === 0 ? 64 : 48,
            y: 0
          });
        });

        // Scroll progress 阈值（与 sections/E6000-10-11.liquid 顶部备注一致）
        var INTRO_HOLD_PROGRESS = 0.18; // 定屏后先停留，再进入主要动效
        var LINE_REVEAL_AT = 0.12 + INTRO_HOLD_PROGRESS; // 折线露出
        var FRAME_HERO_AT = 0.32 + INTRO_HOLD_PROGRESS; // 手机框淡入 + hero 淡出（折线露出后多滚一段再触发）
        var SECOND_SCREEN_AT = 0.54 + INTRO_HOLD_PROGRESS; // 第一屏 ↔ 第二屏主切换
        var SECOND_SCREEN_SNAP_AT = 0.94; // 末段直接吸附终态，避免 tween 与 scrub 冲突导致闪屏
        var SECOND_SCREEN_DURATION = 1.2;
        var FRAME_HERO_DURATION = 1.2;
        var FRAME_HERO_OUT_DURATION = 0.55;
        var FRAME_HERO_IN_DURATION = 0.65;
        var THRESHOLD_ANIM_EXTRA = 0.5;
        var activeSecondScreenState = 'first';
        var activeLineState = 'hidden';
        var activeHeroVisualState = 'visible';
        var activeFrameHeroState = 'hero';
        var secondScreenTween = null;
        var lineTween = null;
        var frameHeroTween = null;
        var secondPanel = panels[0];
        var lastScrollProgress = 0;

        function lockEndState() {
          killSecondScreenTween();
          killLineTween();
          killFrameHeroTween();

          if (
            activeSecondScreenState === 'second' &&
            activeLineState === 'revealed' &&
            activeHeroVisualState === 'hidden'
          ) {
            if (glow) glow.classList.add('is-hidden');
            return;
          }

          activeLineState = 'revealed';
          activeHeroVisualState = 'hidden';
          activeFrameHeroState = 'frame';
          activeSecondScreenState = 'second';
          if (heroLine) gsap.set(heroLine, { clipPath: 'inset(0 0% 0 0)' });
          if (heroVisual) {
            gsap.set(heroVisual, {
              autoAlpha: 0,
              visibility: 'hidden',
              scale: 0.78,
              pointerEvents: 'none'
            });
          }
          gsap.set(phone, { opacity: 1, visibility: 'visible' });
          if (phoneFrame) gsap.set(phoneFrame, { opacity: 1 });
          if (phoneScreens) gsap.set(phoneScreens, { opacity: 1 });
          if (screens[0]) {
            gsap.set(screens[0], { opacity: 1, visibility: 'visible' });
          }
          snapSecondScreenState('second');
          if (glow) glow.classList.add('is-hidden');
        }

        function killLineTween() {
          if (lineTween) {
            lineTween.kill();
            lineTween = null;
          }
        }

        function killFrameHeroTween() {
          if (frameHeroTween) {
            frameHeroTween.kill();
            frameHeroTween = null;
          }
        }

        function snapFrameHeroState(state) {
          var showFrame = state === 'frame';
          activeFrameHeroState = state;
          activeHeroVisualState = showFrame ? 'hidden' : 'visible';

          gsap.set(phone, {
            opacity: showFrame ? 1 : 0,
            visibility: 'visible'
          });
          if (phoneFrame) gsap.set(phoneFrame, { opacity: showFrame ? 1 : 0 });
          if (heroVisual) {
            gsap.set(heroVisual, {
              autoAlpha: showFrame ? 0 : 1,
              visibility: showFrame ? 'hidden' : 'visible',
              scale: showFrame ? 0.78 : 1,
              pointerEvents: showFrame ? 'none' : 'auto'
            });
          }
          if (glow) {
            if (showFrame) glow.classList.add('is-hidden');
            else glow.classList.remove('is-hidden');
          }
        }

        function playFrameHeroTransition() {
          if (activeFrameHeroState === 'frame') return;
          activeFrameHeroState = 'frame';
          activeHeroVisualState = 'hidden';
          killFrameHeroTween();

          frameHeroTween = gsap.timeline({
            defaults: { ease: 'power2.inOut', overwrite: 'auto' }
          });

          frameHeroTween.set(phone, { opacity: 1, visibility: 'visible' }, 0);
          if (phoneFrame) frameHeroTween.set(phoneFrame, { opacity: 0 }, 0);
          if (glow) glow.classList.add('is-hidden');

          if (heroVisual) {
            frameHeroTween.to(heroVisual, {
              autoAlpha: 0,
              visibility: 'hidden',
              scale: 0.78,
              duration: FRAME_HERO_OUT_DURATION,
              ease: 'power2.in'
            }, 0);
          }

          if (phoneFrame) {
            frameHeroTween.to(phoneFrame, {
              opacity: 1,
              duration: FRAME_HERO_IN_DURATION,
              ease: 'power2.out'
            }, 0);
          }

          if (phoneScreens) {
            frameHeroTween.set(phoneScreens, { opacity: 1 }, 0);
          }

          if (screens[0]) {
            frameHeroTween.to(screens[0], {
              opacity: 1,
              visibility: 'visible',
              duration: FRAME_HERO_IN_DURATION,
              ease: 'power2.out'
            }, 0);
          }
        }

        function reverseFrameHeroTransition() {
          if (activeFrameHeroState === 'hero') return;
          activeFrameHeroState = 'hero';
          activeHeroVisualState = 'visible';
          killFrameHeroTween();

          frameHeroTween = gsap.timeline({
            defaults: { ease: 'power2.inOut', overwrite: 'auto' }
          });

          if (phoneFrame) {
            frameHeroTween.to(phoneFrame, {
              opacity: 0,
              duration: FRAME_HERO_OUT_DURATION,
              ease: 'power2.in'
            }, 0);
          }

          if (heroVisual) {
            frameHeroTween.to(heroVisual, {
              autoAlpha: 1,
              visibility: 'visible',
              scale: 1,
              duration: FRAME_HERO_IN_DURATION,
              ease: 'power2.out'
            }, FRAME_HERO_OUT_DURATION);
          }

          frameHeroTween.to(phone, {
            opacity: 0,
            duration: 0.01
          }, FRAME_HERO_DURATION);

          if (phoneScreens) {
            frameHeroTween.set(phoneScreens, { opacity: 0 }, 0);
          }
          if (screens[0]) {
            frameHeroTween.set(screens[0], { opacity: 0, visibility: 'visible' }, 0);
          }

          if (glow) glow.classList.remove('is-hidden');
        }

        function revealHeroLine() {
          if (!heroLine || activeLineState === 'revealed') return;
          activeLineState = 'revealed';
          killLineTween();
          lineTween = gsap.to(heroLine, {
            clipPath: 'inset(0 0% 0 0)',
            duration: 0.24 + THRESHOLD_ANIM_EXTRA,
            ease: 'power2.out'
          });
        }

        function hideHeroLine() {
          if (!heroLine || activeLineState === 'hidden') return;
          activeLineState = 'hidden';
          killLineTween();
          lineTween = gsap.to(heroLine, {
            clipPath: 'inset(0 100% 0 0)',
            duration: 0.18 + THRESHOLD_ANIM_EXTRA,
            ease: 'power2.in'
          });
        }

        function killSecondScreenTween() {
          if (secondScreenTween) {
            secondScreenTween.kill();
            secondScreenTween = null;
          }
        }

        function snapSecondScreenState(state) {
          var isSecond = state === 'second';

          if (heroText) {
            gsap.set(heroText, {
              autoAlpha: isSecond ? 0 : 1,
              x: isSecond ? -58 : 0
            });
          }
          if (secondPanel) {
            gsap.set(secondPanel, {
              autoAlpha: isSecond ? 1 : 0,
              x: isSecond ? 0 : 64
            });
          }
          if (bgScene) gsap.set(bgScene, { opacity: isSecond ? 1 : 0 });
          if (bgImg) gsap.set(bgImg, { scale: isSecond ? 1 : 1.12 });
          if (bgOverlay) gsap.set(bgOverlay, { opacity: isSecond ? 0.12 : 1 });
          if (screens[0]) {
            gsap.set(screens[0], {
              y: isSecond ? '-100%' : '0%',
              opacity: isSecond ? 0 : 1,
              visibility: 'visible'
            });
          }
          if (screens[1]) {
            gsap.set(screens[1], {
              y: isSecond ? '0%' : '100%',
              opacity: isSecond ? 1 : 0,
              visibility: isSecond ? 'visible' : 'hidden'
            });
          }
        }

        function playSecondScreen() {
          if (activeSecondScreenState === 'second') return;
          activeSecondScreenState = 'second';
          killSecondScreenTween();

          var dur = SECOND_SCREEN_DURATION;
          secondScreenTween = gsap.timeline({
            defaults: { ease: 'power2.inOut', overwrite: 'auto' }
          });

          if (heroText) {
            secondScreenTween.to(
              heroText,
              { autoAlpha: 0, x: -58, duration: dur * 0.35, ease: 'power2.in' },
              0
            );
          }
          if (secondPanel) {
            secondScreenTween.fromTo(
              secondPanel,
              { autoAlpha: 0, x: 48 },
              { autoAlpha: 1, x: 0, duration: dur * 0.4, ease: 'power2.out' },
              0
            );
          }
          if (bgScene) {
            secondScreenTween.to(bgScene, { opacity: 1, duration: dur, ease: 'power2.out' }, 0);
          }
          if (bgImg) {
            secondScreenTween.to(bgImg, { scale: 1, duration: dur, ease: 'power2.out' }, 0);
          }
          if (bgOverlay) {
            secondScreenTween.to(bgOverlay, { opacity: 0.12, duration: dur, ease: 'power2.out' }, 0);
          }
          if (screens[1]) {
            secondScreenTween.to(
              screens[0],
              { y: '-100%', opacity: 0, duration: dur * 0.45, ease: 'power2.inOut' },
              0
            );
            secondScreenTween.fromTo(
              screens[1],
              { y: '100%', opacity: 0, visibility: 'hidden' },
              {
                y: '0%',
                opacity: 1,
                visibility: 'visible',
                duration: dur * 0.45,
                ease: 'power2.inOut'
              },
              0
            );
          }
        }

        function playFirstScreen() {
          if (activeSecondScreenState === 'first') return;
          activeSecondScreenState = 'first';
          killSecondScreenTween();

          var dur = SECOND_SCREEN_DURATION;
          secondScreenTween = gsap.timeline({
            defaults: { ease: 'power2.inOut', overwrite: 'auto' }
          });

          if (screens[1]) {
            secondScreenTween.to(
              screens[1],
              { y: '100%', opacity: 0, duration: dur * 0.4, ease: 'power2.inOut' },
              0
            );
            secondScreenTween.to(
              screens[0],
              { y: '0%', opacity: 1, visibility: 'visible', duration: dur * 0.4, ease: 'power2.inOut' },
              0
            );
          }
          if (bgScene) {
            secondScreenTween.to(bgScene, { opacity: 0, duration: dur * 0.5, ease: 'power2.in' }, 0);
          }
          if (bgImg) {
            secondScreenTween.to(bgImg, { scale: 1.12, duration: dur * 0.5, ease: 'power2.in' }, 0);
          }
          if (bgOverlay) {
            secondScreenTween.to(bgOverlay, { opacity: 1, duration: dur * 0.5, ease: 'power2.in' }, 0);
          }
          if (secondPanel) {
            secondScreenTween.to(
              secondPanel,
              { autoAlpha: 0, x: 48, duration: dur * 0.35, ease: 'power2.in' },
              0
            );
          }
          if (heroText) {
            secondScreenTween.to(
              heroText,
              { autoAlpha: 1, x: 0, duration: dur * 0.4, ease: 'power2.out' },
              0
            );
          }
        }

        var tl = gsap.timeline({
          scrollTrigger: {
            id: 'e6000-10-11-' + (section.dataset.sectionId || ''),
            trigger: track,
            start: 'top top',
            end: function () {
              return '+=' + scrollDistance;
            },
            scrub: 1.15,
            refreshPriority: 20,
            onUpdate: function (self) {
              var progress = self.progress;
              var scrollingBack = progress < lastScrollProgress - 0.002;
              lastScrollProgress = progress;

              if (progress >= SECOND_SCREEN_SNAP_AT) {
                lockEndState();
                return;
              }

              if (progress >= LINE_REVEAL_AT) {
                revealHeroLine();
              } else if (scrollingBack) {
                hideHeroLine();
              }

              if (progress >= FRAME_HERO_AT) {
                playFrameHeroTransition();
              } else if (scrollingBack) {
                reverseFrameHeroTransition();
              }

              if (progress >= SECOND_SCREEN_AT) {
                playSecondScreen();
              } else if (scrollingBack) {
                playFirstScreen();
              }
            },
            onLeave: function (self) {
              if (self.direction === 1) lockEndState();
            },
            onEnterBack: function (self) {
              lastScrollProgress = self.progress;
            },
            onRefresh: function (self) {
              lastScrollProgress = self.progress;
              killLineTween();
              killFrameHeroTween();
              killSecondScreenTween();

              if (self.progress >= SECOND_SCREEN_SNAP_AT) {
                lockEndState();
                return;
              }

              if (self.progress >= LINE_REVEAL_AT) {
                activeLineState = 'revealed';
                if (heroLine) gsap.set(heroLine, { clipPath: 'inset(0 0% 0 0)' });
              } else {
                activeLineState = 'hidden';
                if (heroLine) gsap.set(heroLine, { clipPath: 'inset(0 100% 0 0)' });
              }

              if (self.progress >= FRAME_HERO_AT) {
                snapFrameHeroState('frame');
                if (phoneScreens) gsap.set(phoneScreens, { opacity: 1 });
                if (screens[0]) gsap.set(screens[0], { opacity: 1, visibility: 'visible' });
              } else {
                snapFrameHeroState('hero');
                if (phoneScreens) gsap.set(phoneScreens, { opacity: 0 });
                if (screens[0]) gsap.set(screens[0], { opacity: 0, visibility: 'visible' });
              }

              if (self.progress >= SECOND_SCREEN_AT) {
                activeSecondScreenState = 'second';
                snapSecondScreenState('second');
              } else {
                activeSecondScreenState = 'first';
                snapSecondScreenState('first');
              }
            }
          }
        });

        // Timeline progress（scrub，与 onUpdate 阈值配合）：
        //   ~0.50     — FRAME_HERO_AT：hero→手机框约 1.2s 序列动效（非 scrub）
        //   0.68–0.95 — 手机位移缩放；≥0.72 时 onUpdate 切换第二屏
        //   ~0.94+    — 保持终态
        var INTRO_HOLD_TIME = 0.18;
        function delayedTime(time) {
          return time + INTRO_HOLD_TIME;
        }

        tl.to(phone, {
          x: finalX,
          y: finalY,
          scale: finalScale,
          duration: 0.34,
          ease: 'power2.inOut'
        }, delayedTime(0.50));

        if (scrollHint) {
          tl.to(scrollHint, {
            opacity: 0,
            y: 14,
            duration: 0.1
          }, delayedTime(0.46));
        }

        // 4. Optional later screen/panel changes.
        var switchStart = 0.72;
        var switchCount = Math.max(screens.length - 2, 1);
        var switchStep = (1 - switchStart) / switchCount;

        for (var i = 2; i < screens.length; i++) {
          var at = switchStart + (i - 2) * switchStep;

          tl.to(screens[i - 1], {
            y: '-100%',
            opacity: 0,
            duration: switchStep * 0.48,
            ease: 'power2.inOut'
          }, at);

          tl.fromTo(screens[i],
            { y: '100%', opacity: 0, visibility: 'hidden' },
            { y: '0%', opacity: 1, visibility: 'visible', duration: switchStep * 0.48, ease: 'power2.inOut' },
            at
          );

          if (panels[i - 1]) {
            tl.to(panels[i - 1], {
              opacity: 0,
              x: -36,
              duration: switchStep * 0.24,
              ease: 'power1.in'
            }, at);
          }

          if (panels[i]) {
            tl.fromTo(panels[i],
              { opacity: 0, visibility: 'hidden', x: 48 },
              { opacity: 1, visibility: 'visible', x: 0, duration: switchStep * 0.3, ease: 'power2.out' },
              at + switchStep * 0.18
            );
          }
        }

        tl.to({}, { duration: 0.15 });
      }, section);
    });
  }

  function init() {
    hasInitialized = true;
    if (mobileQuery.matches) {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        if (typeof window.samduoLoadGSAP === 'function') {
          window.samduoLoadGSAP().then(initMobileScreens).catch(initMobileScreens);
          return;
        }
      }

      initMobileScreens();
      return;
    }

    if (typeof window.samduoLoadGSAP === 'function') {
      window.samduoLoadGSAP().then(runDesktop).catch(function () {
        setTimeout(init, 100);
      });
      return;
    }

    runDesktop();
  }

  function scheduleInit() {
    var section = document.querySelector('.scroll-morph-v5');
    if (!section) return;

    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
      init();
      return;
    }

    if (initObserver) initObserver.disconnect();
    initObserver = new IntersectionObserver(function (entries) {
      var shouldInit = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      if (!shouldInit) return;
      initObserver.disconnect();
      initObserver = null;
      prepareSectionImages(section);
      init();
    }, { rootMargin: '150% 0px' });
    initObserver.observe(section);
  }

  function destroySection(section) {
    if (!section) return;

    var track = section.querySelector('.scroll-morph-v5__track');
    if (track) track.style.height = '';

    if (section.__scrollMorphContext) {
      section.__scrollMorphContext.revert();
      section.__scrollMorphContext = null;
    }

    if (section.__scrollMorphMobileObserver) {
      section.__scrollMorphMobileObserver.disconnect();
      section.__scrollMorphMobileObserver = null;
    }

    delete section.dataset.scrollMorphReady;
  }

  window.__samduoScrollMorphV5Init = scheduleInit;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  if (typeof window.samduoOnResize === 'function') {
    window.samduoOnResize(function () {
      var viewportWidth = window.innerWidth;
      var mobileState = mobileQuery.matches;
      var widthChanged = Math.abs(viewportWidth - lastViewportWidth) >= 8;
      var breakpointChanged = mobileState !== lastMobileState;

      if (!widthChanged && !breakpointChanged) return;

      lastViewportWidth = viewportWidth;
      lastMobileState = mobileState;
      document.querySelectorAll('.scroll-morph-v5').forEach(destroySection);
      if (hasInitialized) init();
      else scheduleInit();
    });
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.scroll-morph-v5');
    if (initObserver) {
      initObserver.disconnect();
      initObserver = null;
    }
    destroySection(section);
    if (typeof window.samduoRefreshScrollTrigger === 'function') {
      window.samduoRefreshScrollTrigger();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.scroll-morph-v5')) scheduleInit();
  });
})();
